import { render, staticRenderFns } from "./algorithmSet.vue?vue&type=template&id=27be395e&scoped=true"
import script from "./algorithmSet.vue?vue&type=script&lang=js"
export * from "./algorithmSet.vue?vue&type=script&lang=js"
import style0 from "./algorithmSet.vue?vue&type=style&index=0&id=27be395e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_df42b2ab6613268ca01723f0a843be52/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27be395e",
  null
  
)

export default component.exports